import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { getStorage } from "../../../utils/storage";
import axios from "axios";
import { Table } from "../../Table";
import { CSVLink } from "react-csv";
import handleSearch from "../../../utils/handleSearch";
import toastMessage from "../../../utils/toastMessage";
import handleFilters from "../../../utils/handleFilters";
import moment from "moment";
import icons from "../../../constants/icons";

let copyData = [];

class PerCenter extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    csvData: [],
    total: 0,
    filters: {
      startDate: moment().startOf("D").format("YYYY-MM-DD"),
      endDate: moment().endOf("D").format("YYYY-MM-DD"),
    },
  };

  componentDidMount = async () => {
    await this.getData(true, this.state.filters);
  };

  componentDidUpdate(prevProps) {
    if (this.props.filters !== prevProps.filters) {
      this.getData(true);
    }
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: "O+",
        key: "O+",
      },
      {
        title: "O-",
        key: "O-",
      },
      {
        title: "A+",
        key: "A+",
      },
      {
        title: "A-",
        key: "A-",
      },
      {
        title: "B+",
        key: "B+",
      },
      {
        title: "B-",
        key: "B-",
      },
      {
        title: "AB+",
        key: "AB+",
      },
      {
        title: "AB-",
        key: "AB-",
      },
      {
        title: "Unspecified",
        key: "unspecified",
      },
      {
        title: "Total",
        key: "total",
      },
    ];

    return headers;
  }

  getData = async (isLoading, search = {}) => {
    try {
      let total = 0;
      const user = await getStorage();

      this.setState({ isLoading });

      const filters = handleFilters(search);

      const params = {
        ...filters,
      };

      const options = {
        url: process.env.REACT_APP_BBMS_BASE_API + "/bloodDonation/bloodGroup",
        method: "get",
        params,
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios(options);

      data.forEach((item) => {
        total += item.total;
      });

      this.setState({
        data,
        isLoading: false,
        total,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      toastMessage("error", error);
    }
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e?.target?.value,
            })
          }
          isLoading={this.state.isLoading}
          headers={this.returnTableHeaders()}
          fetchData={(isLoading, filters) => this.getData(isLoading, filters)}
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.getData(true, this.state.filters),
            },
            {
              type: "button",
              title: "Filter",
              button_type: "dropdown",
              filterName: "date_range",
              ...this.state.filters,
            },
          ]}
        />

        <div className="alert alert-info">
          {language[this.props.defaultLanguage].total}:{" "}
          <strong>{this.state.total}</strong>{" "}
        </div>

        <CSVLink
          ref={this.csvDownload}
          filename={"Donation per center blood Group"}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(PerCenter);
